﻿import { setDropdown } from './form-controls';

window.AnalysisRequestAppJs =
    window.AnalysisRequestAppJs ||
    (function () {
        var settings = {};
        var companyInfoKeys = [
            'Address',
            'Email',
            'MobilePhoneNumber',
            'Name',
            'PhoneNumber',
            'PostalAddress',
        ];
        var $companyInfoElements = $companyInfoElements || {};
        var beforeValidation = true;

        // I don't dare to remove $formEl if it's used somewhere else
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var $formEl;
        var formValidator;

        var saveRequestData = {
            Address: '',
            AnalysisPackage: '',
            Article: '',
            CustomerName: 'Name',
            CustomerNumber: '',
            Faci: '',
            ItemDescSort: '',
            MobilePhone: 'MobilePhoneNumber',
            OtherInformation: '',
            Phone: 'PhoneNumber',
            PostalAddress: '',
            Trigger: '',
            Weight: '',
        };

        var getIndexPageUrl = function () {
            var formUrl = window.location.href;
            var urlArr = formUrl.split('/');
            var segment = urlArr.pop();
            var backUrl = formUrl.replace(segment, '');
            return backUrl;
        };

        /**
         * @description Initializes the form validation for the analysis request form.
         * @returns {object} Returns the jQuery validation object for the form.
         */
        const initValidation = () => {

            return $('#AnalysisRequestForm').validate({
                ignore: [],
                errorElementClass: 'error',
                errorClass: 'error-item',
                errorElement: 'span',
                rules: {
                    Faci: {
                        required: true,
                    },
                    CustomerNumber: {
                        required: true,
                    },
                    Name: {
                        required: true,
                    },
                    Article: {
                        required: true,
                    },
                    Weight: {
                        required: true,
                    },
                    AnalysisPackage: {
                        required: true,
                    },
                    OtherInformation: {
                        maxlength: 60,
                    },
                },
                messages: {
                    Faci: {
                        required: 'Detta fält är obligatoriskt.',
                    },
                    CustomerNumber: {
                        required: 'Detta fält är obligatoriskt.',
                    },
                    Article: {
                        required: 'Detta fält är obligatoriskt.',
                    },
                    Weight: {
                        required: 'Ange vikt i ton',
                    },
                    AnalysisPackage: {
                        required: 'Detta fält är obligatoriskt.',
                    },
                    OtherInformation: {
                        maxlength: 'Övrig information får vara max 60 tecken.',
                    },
                },
                highlight: function (element, errorClass) {
                    $('li#p_' + $(element).attr('name')).show();
                    var errors = $('ul.errors-list li').filter(function () {
                        return $(this).css('display') === 'list-item';
                    }).length;
                    if (errors >= 3) {
                        $('ul.errors-list').show();
                    }
                    $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
                },
                unhighlight: function (element, errorClass) {
                    $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
                    $('li#p_' + $(element).attr('name')).hide();
                    var errors = $('ul.errors-list li').filter(function () {
                        return $(this).css('display') === 'list-item';
                    }).length;
                    if (
                        $('ul.errors-list').find('li[id^="p"]').is(':visible') === false ||
                        errors < 3
                    ) {
                        $('ul.errors-list').hide();
                    }
                },
                errorPlacement: function (error, element) {
                    element.after(error);
                },
            });
        };

        var initCompanyInfoElements = function () {
            companyInfoKeys.forEach(function (v) {
                var $el = $('#' + v);
                $companyInfoElements[v] = $el;
            });
        };

        var getCompanyInfo = async function (customerId) {
            const url = '/api/analysis-request/get-company-info/' + customerId;

            try {
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }

                const jsonResponse = await response.json();
                for (var el in $companyInfoElements) {
                    if (Object.prototype.hasOwnProperty.call($companyInfoElements, el)) {
                        $companyInfoElements[el].val(jsonResponse[el]);
                    }
                }
            } catch (error) {
                console.error("Request 'get-company-info' failed: " + error.message);
            }
        };

        /**
         * @description Populate customer info from the current customer number on customer number change
         * @returns {void}
         */
        const initCustomerNumberChange = () => {
            if (document.querySelector('#AnalysisRequestForm').length > 0) {
                document.getElementById("CustomerNumber").addEventListener("change", function () {
                    initCustomerListEvent(true);
                });
            }
        }

        var resetPopover = function () {
            $('.packages').popover('hide');

            var popover = $('.packages').data('bs.popover');
            var popoverContent = 'Välj ett analyspaket för ingående information.';

            popover.options.html = true;
            popover.options.content = popoverContent;
        };
        var selectCustomer = function (item) {
            $('<div>')
                .text('Selected: ' + item.value + ' aka ' + item.id)
                .prependTo('#CustomerListResult');
            $('#CustomerListResult').scrollTop(0);
            getCompanyInfo(item.value);
        };

        var initCustomerListEvent = function (onChange) {
            $('#CustomerNumber')
                .autocomplete({
                    source: '/api/analysis-request/get-customer-list/',
                    minLength: 4,
                    select: function (event, ui) {
                        selectCustomer(ui.item);
                    },
                })
                .autocomplete('instance')._renderItem = function (ul, item) {
                    return $('<li>')
                        .append('<div>' + item.label + '<br>' + item.desc + '</div>')
                        .appendTo(ul);
                };

            /**
             * Populate customer info from the current customer number on internal site
             * User typing and is no using auto complete.
             */
            if (onChange) {
                const customerNumber = $('#CustomerNumber').val();

                if (customerNumber) {
                    $.ajax({
                        url: '/api/analysis-request/get-customer-list/',
                        data: { term: customerNumber },
                        success: function (response) {
                            const matchedCustomer = response.find((item) => item.value === customerNumber);

                            if (matchedCustomer) {
                                selectCustomer(matchedCustomer);
                            } else {
                                console.warn('Ingen matchande kund hittades för: ' + customerNumber);
                            }
                        },
                        error: function () {
                            console.error('Kunde inte hämta kundinformation.');
                        },
                    });
                }
            }
        };

        /**
         * Populate customer info from the current customer number on internal site
         */
        var populateCustomerInfo = function () {
            const currentCustomerNumber = $('#currentCustomerNumber');
            const customerNumber = currentCustomerNumber.data('value');
            if (!customerNumber) {
                return;
            }

            $('#CustomerNumber').val(customerNumber);
            getCompanyInfo(customerNumber);
        };

        var initTriggerEvent = function () {
            $('#SelectTrigger').on('change', function () {
                if (!beforeValidation) {
                    formValidator.element('#Trigger');
                }
            });
        };

        var initModalEvent = function () {
            $('.showAnalysisResult').click(function () {
                var modal = $('.lm__modal-alert');
                $('.modal-content-wrapper').html(
                    '<div class="loader-wrapper"><div class="loader"></div></div>'
                );
                modal.fadeIn();
                var url =
                    '/api/analysis-request/get-analysis-result/' +
                    $(this).attr('data-id').toString();
                $.ajax({
                    dataType: 'html',
                    url: url,
                    success: function (data) {
                        $('.modal-content-wrapper').html(data);
                    },
                    error: function () {
                        modal.fadeOut();
                    },
                });
            });
        };

        var renderAnalysisPackageDropdown = function (data) {
            var packagesArr = $.map(data, function (v) {
                return { package: v };
            });
            var dropdownRoot = $('#SelectAnalysisPackage');
            var htmlStr = $.templates('#TmplAnalysisPackage').render({ packages: packagesArr });
            dropdownRoot.html(htmlStr);
            setDropdown(dropdownRoot, 'type-3');
            if (!beforeValidation) {
                formValidator.element('#AnalysisPackage');
            }
            resetPopover();
        };

        var getAnalysisPackageFacility = function (articleNo) {
            var data = [
                encodeURIComponent($('#Faci').val()),
                encodeURIComponent(articleNo),
                encodeURIComponent($('#Trigger').val())
            ];

            var url = '/api/analysis-request/get-analysis-package-facility/' + data.join('/');

            fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok ' + response.statusText);
                    }
                    return response.json();
                })
                .then((data) => {
                    renderAnalysisPackageDropdown(data);
                })
                .catch((error) => {
                    console.error('Request failed: ' + error.message);
                });
        };

        var initAnalysisPackageFacilityEvent = function () {
            $('#SelectArticle').on('change', function (event, data) {
                if (data && data.data) {
                    getAnalysisPackageFacility(data.data);
                    $('#ItemDescSort').val(data.data + ' ' + data.dataText);
                }
                if (!beforeValidation) {
                    formValidator.element('#Article');
                }
            });
        };

        var postData = { AnalysisId: '', AnalysisRequestDto: {} };

        var saveRequest = async function () {
            const saveButton = document.getElementById('saveRequest');
            saveButton.disabled = true;

            var isValid = $('#AnalysisRequestForm').valid();
            beforeValidation = false;

            if (!isValid) {
                saveButton.disabled = false;
                return;
            }

            var val;
            for (var f in saveRequestData) {
                if (Object.prototype.hasOwnProperty.call(saveRequestData, f)) {
                    val = saveRequestData[f].length > 0 ? saveRequestData[f] : f;
                    postData.AnalysisRequestDto[f] = $('#' + val).val();
                }
            }

            try {
                const response = await fetch('/api/analysis-request/save-analysis/', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                    },
                    body: JSON.stringify(postData.AnalysisRequestDto),
                });

                if (!response.ok) {
                    throw new Error('The "saveRequest" was not ok ' + response.statusText);
                }

                const data = await response.json();

                if (!data.Data.SaveAnalysisResult) {
                    console.log('Could not save anmodan.');
                    const modal = document.querySelector('.lm__information-modal__wrapper');
                    modal.classList.remove('hidden');
                    return;
                }

                const url = getIndexPageUrl();
                var articleNumber = postData.AnalysisRequestDto['Article'];
                var analysisId = data.Data.AnalysisId;
                window.location.href = url + 'preview?analysisId=' + analysisId + '&articleNo=' + articleNumber;
            } catch (error) {
                console.error('Request failed: ' + error.message);
                const modal = document.querySelector('.lm__information-modal__wrapper');
                modal.classList.remove('hidden');
            } finally {
                saveButton.disabled = false;
            }
        };

        var initSaveEvent = function () {
            $('#saveRequest').on('click', function () {
                saveRequest();
            });
        };

        var getPdf = function () {
            var getUri = '/api/pdfhandler/analysis-request?analysisId=' + settings.analysisId + '&';
            getUri += 'listingUrl=';
            var relativePath = window.location.pathname.split('/');
            relativePath.pop();

            if (window.location.pathname.startsWith('/lm/')) {
                relativePath = relativePath.filter(function (val) {
                    return !!val;
                });
                relativePath.shift();
            }
            getUri += '/' + relativePath.join('/');
            getUri += '&pdfUrlSegment=/showpdf';
            window.open(getUri);
        };

        var initGetPdf = function () {
            $('#PrintAnalysisRequestBtn').on('click', function () {
                getPdf();
            });
        };

        var initCancelEvent = function () {
            $('#cancelAnalysisRequest').on('click', function () {
                window.location.href = getIndexPageUrl();
            });
        };

        /**
         * Event for back to analysis list button in Show.cshtml file
         * Redirects to the analysis list page
         */
        var initBackToAnalysisListEvent = function () {
            $('#backToAnalysisListBtnHeader').on('click', function (event) {
                event.preventDefault();
                window.location.href = getIndexPageUrl();
            });
        };

        var init = function (params) {
            if (params) {
                $.extend(settings, params);
            }

            $formEl = $('#RequestAnalysisForm');

            initTriggerEvent();
            initCustomerListEvent(false);
            initCompanyInfoElements();
            initAnalysisPackageFacilityEvent();
            initSaveEvent();
            initCancelEvent();
            initModalEvent();
            initGetPdf();
            initBackToAnalysisListEvent();

            formValidator = initValidation();

            if (params?.isInternalSite && params?.isCreate) {
                populateCustomerInfo();
            }

            initCustomerNumberChange();
        };

        return {
            init: init,
        };
    })();
